import React from 'react';
import { featureFlags } from '@/utils/featureFlags';

export type MerchantType = 'direct' | 'reseller';

export type OrgTabType = 'overview' | 'reports' | 'inventory' | 'billing' | 'data' | 'files' | 'settings' | 'purchase-orders';

interface OrganisationTabsProps {
  activeTab: OrgTabType;
  setActiveTab: (tab: OrgTabType) => void;
  hasConnections: boolean;
  hasFiles: boolean;
  isAdmin?: boolean;
  merchantType?: MerchantType;
  isTestClone?: boolean;
}

const OrganisationTabs: React.FC<OrganisationTabsProps> = ({
  activeTab,
  setActiveTab,
  hasConnections,
  hasFiles,
  isAdmin = false,
  merchantType = 'direct',
  isTestClone = false
}) => {
  const isReseller = merchantType === 'reseller';

  return (
    <div data-testid="organisation-tabs" className="flex border-b mb-6 overflow-x-auto">
      <button
        className={`px-4 py-2 font-medium ${activeTab === 'overview'
          ? 'text-blue-600 border-b-2 border-blue-600'
          : 'text-gray-500 hover:text-gray-700'
          }`}
        onClick={() => setActiveTab('overview')}
      >
        Overview
      </button>
      <button
        className={`px-4 py-2 font-medium ${activeTab === 'reports'
          ? 'text-blue-600 border-b-2 border-blue-600'
          : 'text-gray-500 hover:text-gray-700'
          }`}
        onClick={() => setActiveTab('reports')}
      >
        Reports
      </button>
      <button
        className={`px-4 py-2 font-medium ${activeTab === 'inventory'
          ? 'text-blue-600 border-b-2 border-blue-600'
          : 'text-gray-500 hover:text-gray-700'
          }`}
        onClick={() => setActiveTab('inventory')}
      >
        Inventory
      </button>
      {featureFlags.showOrgBilling && !isTestClone && (
        <button
          className={`px-4 py-2 font-medium ${activeTab === 'billing'
            ? 'text-blue-600 border-b-2 border-blue-600'
            : 'text-gray-500 hover:text-gray-700'
            }`}
          onClick={() => setActiveTab('billing')}
          disabled={!hasConnections}
        >
          Billing
          {!hasConnections && (
            <span className="ml-2 px-2 py-0.5 text-xs bg-gray-200 text-gray-600 rounded">
              No Data
            </span>
          )}
        </button>
      )}
      <button
        className={`px-4 py-2 font-medium ${activeTab === 'data'
          ? 'text-blue-600 border-b-2 border-blue-600'
          : 'text-gray-500 hover:text-gray-700'
          }`}
        onClick={() => setActiveTab('data')}
        disabled={!hasConnections}
      >
        Data
        {!hasConnections && (
          <span className="ml-2 px-2 py-0.5 text-xs bg-gray-200 text-gray-600 rounded">
            No Data
          </span>
        )}
      </button>
      <button
        className={`px-4 py-2 font-medium ${activeTab === 'files'
          ? 'text-blue-600 border-b-2 border-blue-600'
          : 'text-gray-500 hover:text-gray-700'
          }`}
        onClick={() => setActiveTab('files')}
        disabled={!hasFiles}
      >
        Files
        {!hasFiles && (
          <span className="ml-2 px-2 py-0.5 text-xs bg-gray-200 text-gray-600 rounded">
            No Files
          </span>
        )}
      </button>
      {isReseller && (
        <button
          data-testid="purchase-orders-tab"
          className={`px-4 py-2 font-medium flex items-center gap-1 ${activeTab === 'purchase-orders'
            ? 'text-blue-600 border-b-2 border-blue-600'
            : 'text-gray-500 hover:text-gray-700'
            }`}
          onClick={() => setActiveTab('purchase-orders')}
        >
          Purchase Orders
        </button>
      )}
      {
        <button
          className={`px-4 py-2 font-medium flex items-center gap-1 ${activeTab === 'settings'
            ? 'text-blue-600 border-b-2 border-blue-600'
            : 'text-gray-500 hover:text-gray-700'
            }`}
          onClick={() => setActiveTab('settings')}
        >
          Settings
        </button>
      }
    </div>
  );
};

export default OrganisationTabs;
